<template>
  <div class="flex flex-col justify-center items-center w-full h-screen bg-background absolute">
    <div class="text-center">
      <h1 class="text-9xl font-bold text-primary text-center">{{ props.error?.statusCode }}</h1>
      <p class="text-2xl font-bold text-center">{{ props.error?.statusMessage }}</p>
      <p v-if="props.error?.statusCode === 404" class="text-center text-gray-500">
        {{ $t('pages.error.404') }}
      </p>
      <p v-if="props.error?.statusCode === 500" class="text-center text-gray-500">
        {{ $t('pages.error.500') }}
      </p>

      <StartingPageContactButton class="mt-8" />
      <p class="text-foreground/60 mt-2 text-sm">
        or return to <NuxtLink to="/" class="underline italic font-bold">home</NuxtLink>
      </p>
    </div>

    <AppLogo class="absolute bottom-12" />
  </div>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app';

const props = defineProps({
  error: Object as () => NuxtError,
});
</script>
